import React, { useEffect, useRef, useState } from 'react';

const Loader = () => (
    <div className="loader-overlay">
        <div className="loader">
            <img src="/images/loader_watch.gif" alt="Loading..." style={{ width: '50px', height: '50px' }} />
        </div>
    </div>
);



const SocialMarketAnalyticsWidget = () => {
    const [loading, setLoading] = useState(true);
    const isWidgetLoaded = useRef(false);
    const [error, setError] = useState('');
    const [watchlist, setWatchlist] = useState([]);
    const [watchlistLoading, setWatchlistLoading] = useState(false);
    const [watchlistFetched, setWatchlistFetched] = useState(false);
    
    const userApikey = JSON.parse(sessionStorage.getItem('userApikey')) || "";

    // const userApikey =  "7f312ea16da63b9407109bd0fe863cf77c298980";


    // console.log('sssssssssssss');
    // console.log(userApikeS);
    //const userApikey ="";

    // Fetch watchlist function
    const fetchWatchlist = async () => {
        try {
            setWatchlistLoading(true);

            // Get userId and auth_token from sessionStorage
            const userIdRaw = sessionStorage.getItem('userId');
            const authTokenRaw = sessionStorage.getItem('token');
            
            // Parse only if not null/undefined
            const userId = userIdRaw && userIdRaw !== 'undefined' ? JSON.parse(userIdRaw) : null;
            const auth_token = authTokenRaw && authTokenRaw !== 'undefined' ? JSON.parse(authTokenRaw) : null;
            
            if (!userId || !auth_token) {
                console.error('User information not found for watchlist');
                setWatchlistLoading(false);
                setWatchlistFetched(true);
                return;
            }

            // Construct the API URL with userId and token as query params
            const apiUrl = `/api/watchlist?userId=${userId}&token=${auth_token}`;
            
            console.log('=== Fetching Watchlist in Dashboard ===');
            console.log('URL:', apiUrl);

            // Fetch watchlist
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch watchlist: ${response.statusText}`);
            }

            const data = await response.json();
            console.log('Watchlist Data:', data.data || data);
            setWatchlist(data.data || data || []);
        } catch (err) {
            console.error('Error fetching watchlist:', err);
        } finally {
            setWatchlistLoading(false);
            setWatchlistFetched(true);
        }
    };

    // Fetch watchlist on component mount
    useEffect(() => {
        fetchWatchlist();
    }, []);

    useEffect(() => {
        if (isWidgetLoaded.current || !watchlistFetched) return;

        // Use local widget file instead of remote
        const scriptUrl = `${process.env.PUBLIC_URL || ''}/sma_widget/js/sma_widget.js`;

        const load_widget_env = process.env.REACT_APP_LOAD_WIDGET;
        const load_widget = load_widget_env || 'spreport,emerging_topics,top_sentiment,sentiment,bottom_sentiment,sell_side_firm,short_squeeze,security_level_trend,earnings_watcher,press_release,symbol_cluster,asset_report,fidelity_fraud,fidelity_tiktok_fraud';

        if (!userApikey || userApikey.trim() === '') {
            setError('API key is not generated for this user.');
        } else {
            setError('');
            const existingScript = document.getElementById('sma-widget-script');
            if (!existingScript) {
                const script = document.createElement('script');
                script.src = scriptUrl;
                script.async = true;
                script.id = 'sma-widget-script';

                script.onload = () => {
                    if (window.SMA) {
                        console.log("SMA script loaded successfully.");
                        initializeWidget();
                    } else {
                        console.error("SMA object not found.");
                        setLoading(false);
                    }
                };

                script.onerror = (error) => {
                    console.error("Error loading SMA widget script:", error);
                    setLoading(false);
                };

                console.log('Appending script with src:', scriptUrl);
                document.body.appendChild(script);
            } else if (window.SMA) {
                initializeWidget();
            }
        }

        function initializeWidget() {
            if (!isWidgetLoaded.current) {
                try {
                    // Get watchlist tickers - filter only ticker_type 2 and 40
                    
                    const watchlistSubjects = watchlist
                        .filter(item => item.ticker_type == 2 || item.ticker_type == 40)
                        .map(item => item.subject || item.ticker)
                        .filter(Boolean);
                    
                    console.log('watchlist to widget:', watchlist);
                    console.log('Passing watchlist to widget:', watchlistSubjects);
                    
                    window.SMA.SMAWidgetsGroup({
                        container: 'container-riskdesktop',
                        width: '100%',
                        height: '100%',
                        apikey: userApikey,
                        loadOnly: load_widget,
                        // loadOnly: 'spreport,emerging_topics,top_sentiment,sentiment,bottom_sentiment,sell_side_firm,short_squeeze,security_level_trend,earnings_watcher,press_release,symbol_cluster,asset_report,fidelity_fraud,fidelity_tiktok_fraud',

                        serverDomain: 'finance',
                        customCSS: '.navless-header{display:none;}',
                        config: {
                            top_sentiment: { btn_label: "Top Sentiment", filters: "svolume+gt+13" },
			                widgetFor: 'trending',
                            showWatchlist: true,
                            watchlistSubjects: watchlistSubjects,
                            countryDropdown: true,
                        },
                    });
                    isWidgetLoaded.current = true;
                    setLoading(false);
                } catch (error) {
                    console.error("Error initializing SMA widget:", error);
                    setLoading(false);
                }
            }
        }
    }, [watchlist, userApikey, watchlistFetched]);

    return (
        <div className="content" style={{ position: 'relative', width: '100%', height: '110vh' }}>
            {error ? (
                <div style={{
                    color: 'white',
                    backgroundColor: 'red',
                    padding: '10px',
                    borderRadius: '5px',
                    textAlign: 'center',
                    fontWeight: 800,
                    fontSize: 'larger',
                }}>
                    {error}
                </div>
            ) : (
                loading && <Loader />
            )}
            <div style={{ width: '100%', height: '110vh' }} id="container-riskdesktop"></div>
        </div>

    );
};

export default SocialMarketAnalyticsWidget;
